(() => {
  const modal = document.querySelector('[data-welcome-offer-modal]');
  if (!modal) return;

  const panel = modal.querySelector('[role="dialog"]');
  const form = modal.querySelector('#NhWelcomeOfferForm');
  const formView = modal.querySelector('[data-welcome-offer-form-view]');
  const successView = modal.querySelector('[data-welcome-offer-success]');
  const status = modal.querySelector('[data-welcome-offer-status]');
  const submitButton = modal.querySelector('[data-welcome-offer-submit]');
  const sourceInput = modal.querySelector('[data-welcome-offer-source]');
  const motherNameInput = modal.querySelector('[data-welcome-mother-name]');
  const babyNameInput = modal.querySelector('[data-welcome-baby-name]');
  const babyDateInput = modal.querySelector('[data-welcome-baby-date]');
  const emailInput = modal.querySelector('[data-welcome-email]');
  const trapInput = modal.querySelector('[data-welcome-offer-trap]');
  const shopifyTagsInput = modal.querySelector('[data-welcome-shopify-tags]');
  if (
    !panel
    || !form
    || !formView
    || !successView
    || !status
    || !motherNameInput
    || !babyNameInput
    || !babyDateInput
    || !emailInput
    || !shopifyTagsInput
  ) return;

  const pendingStorageKey = 'nh-private-welcome-offer-pending';
  let lastTrigger = null;
  let bodyLocked = false;
  let allowNativeShopifySubmit = false;
  let originalBodyPaddingRight = '';

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  const isMobileViewport = () => window.matchMedia?.('(max-width: 749px)').matches
    ?? window.innerWidth <= 749;

  const normalizeTextValue = (value) => String(value || '')
    .replace(/[\u0000-\u001f\u007f|;]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const normalizeNameForCode = (value) => normalizeTextValue(value)
    .replace(/[\u0111\u0110]/g, 'D')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 20);

  const getFormValues = () => ({
    motherName: normalizeTextValue(motherNameInput.value),
    babyName: normalizeTextValue(babyNameInput.value),
    babyDate: String(babyDateInput.value || '').trim(),
    email: String(emailInput.value || '').trim().toLowerCase(),
    offerSource: normalizeTextValue(sourceInput?.value || 'site-offer'),
  });

  const lockBodyScroll = () => {
    if (bodyLocked) return;
    originalBodyPaddingRight = document.body.style.paddingRight;
    const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    if (scrollbarWidth > 0) {
      const currentPadding = Number.parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
      document.body.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
    }
    document.body.classList.add('nh-welcome-offer-open');
    bodyLocked = true;
  };

  const unlockBodyScroll = () => {
    if (!bodyLocked) return;
    document.body.classList.remove('nh-welcome-offer-open');
    document.body.style.paddingRight = originalBodyPaddingRight;
    bodyLocked = false;
  };

  const getInitialFocusTarget = () => {
    if (!successView.hidden) return successView.querySelector('button') || panel;
    if (isMobileViewport()) return panel;
    return motherNameInput || panel;
  };

  const setOpenState = (open) => {
    modal.hidden = !open;
    modal.setAttribute('aria-hidden', String(!open));
    if (open) {
      lockBodyScroll();
      window.requestAnimationFrame(() => getInitialFocusTarget()?.focus({ preventScroll: true }));
      return;
    }
    unlockBodyScroll();
    lastTrigger?.focus?.({ preventScroll: true });
  };

  const openModal = (trigger) => {
    lastTrigger = trigger;
    if (sourceInput) sourceInput.value = normalizeTextValue(trigger?.dataset.offerSource || 'site-offer');
    setOpenState(true);
  };

  const closeModal = () => setOpenState(false);

  const validateForm = () => {
    const values = getFormValues();
    motherNameInput.value = values.motherName;
    babyNameInput.value = values.babyName;
    babyDateInput.value = values.babyDate;
    emailInput.value = values.email;

    motherNameInput.setCustomValidity(
      normalizeTextValue(values.motherName) ? '' : "Enter the mother's name.",
    );
    babyNameInput.setCustomValidity(
      normalizeNameForCode(values.babyName) ? '' : "Enter a valid baby's name.",
    );

    return form.reportValidity();
  };

  const prepareShopifyCustomer = ({ motherName, babyName, babyDate, email, offerSource }) => {
    const babyNameToken = normalizeNameForCode(babyName);
    emailInput.value = email;
    shopifyTagsInput.value = [
      'newsletter',
      'private-welcome-offer',
      `nh-baby-first:${babyNameToken}`,
      `nh-baby-dob:${babyDate}`,
    ].join(',');

    const returnToInput = form.querySelector('input[name="return_to"]');
    if (returnToInput) {
      const returnUrl = new URL(window.location.href);
      returnUrl.searchParams.delete('customer_posted');
      returnUrl.searchParams.set('nh_offer_submitted', '1');
      returnUrl.hash = '';
      returnToInput.value = `${returnUrl.pathname}${returnUrl.search}`;
    }

    const pendingRequest = JSON.stringify({
      email,
      motherName,
      babyName,
      babyDate,
      offerSource,
      createdAt: Date.now(),
    });

    try {
      window.sessionStorage.setItem(pendingStorageKey, JSON.stringify({
        email,
        motherName,
        babyName,
        babyDate,
        offerSource,
        createdAt: Date.now(),
      }));
    } catch (_error) {
      try {
        window.name = `${pendingStorageKey}:${pendingRequest}`;
      } catch (_nameError) {
        // The Shopify redirect still completes when browser storage is unavailable.
      }
    }
  };

  const showSuccess = () => {
    formView.hidden = true;
    successView.hidden = false;
    panel.setAttribute('aria-labelledby', 'NhWelcomeOfferSuccessTitle');
    panel.setAttribute('aria-describedby', 'NhWelcomeOfferSuccessDescription');
    successView.querySelector('button')?.focus({ preventScroll: true });
  };

  const setSubmitting = (submitting) => {
    form.toggleAttribute('aria-busy', submitting);
    if (submitButton) submitButton.disabled = submitting;
  };

  const submitForm = async (event) => {
    if (allowNativeShopifySubmit) {
      allowNativeShopifySubmit = false;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.getAttribute('aria-busy') === 'true') return;
    status.textContent = '';

    if (!validateForm()) return;
    if (trapInput?.value) {
      form.reset();
      closeModal();
      return;
    }
    setSubmitting(true);
    const values = getFormValues();

    try {
      // Submit consent through Shopify's customer form. Klaviyo then receives
      // the subscribed profile from the Shopify integration. Calling
      // Klaviyo's client subscription endpoint here caused valid signups to
      // be suppressed as BOT_PROTECTION before the personal-code event ran.
      prepareShopifyCustomer(values);

      allowNativeShopifySubmit = true;
      // requestSubmit() is ignored when it is called re-entrantly from the
      // same submit event. Continue on the next task so Shopify's native
      // customer form and consent handling can complete normally.
      await new Promise((resolve) => window.setTimeout(resolve, 0));
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    } catch (error) {
      status.textContent = error.name === 'AbortError'
        ? 'The request took too long. Check your connection and try again.'
        : error.message?.includes('Shopify verification')
          ? 'Please refresh the page, complete verification and try again.'
        : 'We could not submit your request. Please try again.';
    } finally {
      setSubmitting(false);
    }
  };

  const restoreShopifyResult = () => {
    const resultMarker = form.querySelector('[data-welcome-shopify-result]')?.dataset.welcomeShopifyResult;
    const searchParams = new URLSearchParams(window.location.search);
    const customerPosted = searchParams.get('customer_posted') === 'true';
    const offerSubmitted = searchParams.get('nh_offer_submitted') === '1';
    let pendingRequest;

    try {
      pendingRequest = JSON.parse(window.sessionStorage.getItem(pendingStorageKey) || 'null');
    } catch (_error) {
      const windowNamePrefix = `${pendingStorageKey}:`;
      try {
        pendingRequest = window.name.startsWith(windowNamePrefix)
          ? JSON.parse(window.name.slice(windowNamePrefix.length))
          : null;
      } catch (_nameError) {
        pendingRequest = null;
      }
    }

    const pendingRequestIsFresh = Boolean(
      pendingRequest
      && Date.now() - Number(pendingRequest.createdAt || 0) <= 10 * 60 * 1000,
    );
    const shopifyAccepted = offerSubmitted
      && resultMarker !== 'error'
      && (customerPosted || pendingRequestIsFresh);

    if (shopifyAccepted) {
      try {
        window.sessionStorage.removeItem(pendingStorageKey);
      } catch (_error) {
        if (window.name.startsWith(`${pendingStorageKey}:`)) window.name = '';
      }
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('customer_posted');
      cleanUrl.searchParams.delete('nh_offer_submitted');
      window.history.replaceState({}, '', `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
      showSuccess();
      setOpenState(true);
      return;
    }

    if (!pendingRequestIsFresh) return;

    if (resultMarker === 'error') {
      motherNameInput.value = pendingRequest.motherName || '';
      babyNameInput.value = pendingRequest.babyName || '';
      babyDateInput.value = pendingRequest.babyDate || '';
      emailInput.value = pendingRequest.email || '';
      status.textContent = 'Shopify could not complete your request. Please try again.';
      setOpenState(true);
    }
  };

  const isVisibleFocusable = (element) => {
    if (element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    const styles = window.getComputedStyle(element);
    return styles.display !== 'none'
      && styles.visibility !== 'hidden'
      && (element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-welcome-offer-open]');
    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }
    if (event.target.closest('[data-welcome-offer-close]')) closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (modal.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = [...panel.querySelectorAll(focusableSelector)].filter(isVisibleFocusable);
    if (!focusable.length) {
      event.preventDefault();
      panel.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const activeElement = document.activeElement;
    if (event.shiftKey && (activeElement === first || !panel.contains(activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (activeElement === last || !panel.contains(activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });

  [motherNameInput, babyNameInput, babyDateInput].forEach((input) => {
    input.addEventListener('input', () => input.setCustomValidity(''));
  });
  form.addEventListener('submit', submitForm, true);
  restoreShopifyResult();
})();
